import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { InputV2 } from '../v2';
import { InputShape } from '../v2/input';
import ElidableText from '../elidable-text';
import { useAppState } from '../../hooks';
import usePolicyAnalytics from '../../hooks/policy-analytics.hook';

function EditorName(props) {
  const {
    temporaryObject, isEditing, disabled, validateObject,
  } = props;

  const { features } = useAppState();
  const { loading, analytics, refresh } = usePolicyAnalytics();

  const name = temporaryObject.isTemporary === true && temporaryObject.isUntitled ? '' : temporaryObject.name || temporaryObject.varName;
  const isErrored = temporaryObject.errorArray && temporaryObject.errorArray.includes('name');

  const setEditorName = (event) => {
    const newObject = { ...temporaryObject, name: event.target.value, isUntitled: false };
    validateObject(newObject);
  };

  const trimEditorName = (event) => {
    const newObject = { ...temporaryObject, name: event.target.value.trim() };
    validateObject(newObject);
  };

  // analytics
  const isPolicy = !!(temporaryObject.actions
    && (temporaryObject.condition || temporaryObject.conditions));
  const policyId = temporaryObject.docId;
  const analyticsCount = analytics?.[policyId]?.true;

  useEffect(() => {
    refresh();
  }, [refresh, temporaryObject.docId]);

  return isEditing && !disabled ? (
    <Box width="100%" p={2} mb={2}>
      <Box height="32px">
        <InputV2
          value={name}
          onChange={setEditorName}
          onBlur={trimEditorName}
          disabled={disabled}
          placeholder={temporaryObject.placeHolderText || 'Enter a name'}
          isErrored={isErrored}
          testId="editor-name"
          shape={InputShape.SQUARE}
        />
      </Box>
    </Box>
  ) : (
    <Flex justifyContent="space-between">
      <Text variant="h3" data-testid="editor-name" m={2}>
        <ElidableText text={name} lineCount={1} />
      </Text>

      { features['maven.feature.displayPolicyAnalytics']
        && isPolicy
        && analyticsCount >= 0
        && (
        <Text
          data-testid="editor-analytics"
          variant="h4"
          m={2}
          pt={1}
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Executed over last 30 days:
          {' '}
          <span style={{ color: 'white', fontWeight: 'bold' }}>{analyticsCount}</span>
        </Text>
        )}
    </Flex>
  );
}

EditorName.defaultProps = {
  isEditing: false,
  disabled: false,
};

EditorName.propTypes = {
  disabled: PropTypes.bool,
  isEditing: PropTypes.bool,
  temporaryObject: PropTypes.object.isRequired,
  validateObject: PropTypes.func.isRequired,
};

export default EditorName;
